import { useLogisticaConfiguration, withLogisticaConfiguration } from "./configurazione/LogisticaConfigurationProvider";
import React, { useEffect, useState } from "react";
import _ from "lodash";
import axios from "axios";
import { useAuth0 } from '@auth0/auth0-react';
import stilePulsanti from "../interfaccia/stilePulsanti";
import RicercaAvanzataPochiCampi from "./AreaOrdiniComponenti/DBperAreaOrdiniComponenti/RicercaAvanzataPochiCampi";
import apiUrl from "../Apiurl";
import RiquadrinoOrdine from "./AreaOrdiniComponenti/OrdineComponenti/RiquadrinoOrdine"
import umanizzaDataSenzaOre from "../interfaccia/funzioniComuni/umanizzaDataSenzaOre";
import RiquadrinoArticolo from "./AreaOrdiniComponenti/OrdineComponenti/RiquadrinoArticolo";
import RiquadrinoFornitore from "./AreaOrdiniComponenti/OrdineComponenti/RiquadrinoFornitore";
import RiquadrinoContatto from "./AreaOrdiniComponenti/OrdineComponenti/RiquadrinoContatto";

function CreaGaranzie({
  setGaranzia,
  setNuovaGaranzia,
  idArticolo,
  idSpedizione,
  areaOrdini,
  setTotalRows,
  setRicerca,
  setUrlRicerca,
  setListeOrdiniDaAltrove,
  utente
}) {
  const { tuttiIcampiRicerca } = useLogisticaConfiguration();
const campiRicercaOrdinePerGaranzia = [
  tuttiIcampiRicerca.spedRifPSLIKE,
  tuttiIcampiRicerca.spedFonteEQ,
  tuttiIcampiRicerca.spedRifMPLIKE,
  tuttiIcampiRicerca.spedNomeClienteLIKE,
];

const inputRicercaOrdinePerGaranziaVuoto = {
  [tuttiIcampiRicerca.spedRifPSLIKE.nome]: "",
  [tuttiIcampiRicerca.spedFonteEQ.nome]: "",
  [tuttiIcampiRicerca.spedRifMPLIKE.nome]: "",
  [tuttiIcampiRicerca.spedNomeClienteLIKE.nome]: "",
};



  const [nuovaGaranziaTemp, setNuovaGaranziaTemp] = useState({
    "id": null,
    "idArticolo": null,
    "idSpedPS": null,
    "codGaranziaProduttore": null,
    "idContatto": null,
    "idFornitore": null,
    "idBrand": null,
    "descDifetto": null,
    "idSpedOriginale": null,
    "idSpedAProduttore": null,
    "idSpedRestituzioneCliente": null,
    "dataPromemoria": null,
    "ricordamelo": null,
    "dataRichiestaGaranzia": null,
    "gestito": null,
    "statoGaranzia": "NUOVA",
    "soluzioneProduttore": null,
    "richiestaCliente": null,
    "Cod Viglietti Sport": null,
    "imgIDps": null,
    "prodIDps": null,
    "Descrizione Articolo": null,
    "Produttore": null,
    "nomeCliente": null,
    "dataOrd": null,
    "nomeForn": null,
    "istruzioniReso": null,
    "nomeRappr": null,
    "mailRappr": null,
    "mailRapprCC": null
  }
  )

  const [fase, setFase] = useState(1)
  const [data, setData] = useState([]);
  const [fornitoreInput, setFornitoreInput] = useState(false)
  const [ordineRif, setOrdineRif] = useState(false)
  const [articoloRif, setArticoloRif] = useState(false)
  const [fornitoreRif, setFornitoreRif] = useState(false)
  const [contattoRif, setContattoRif] = useState(false)
  const [arrFornitori, setArrFornitori] = useState([])
  const [arrContatti, setArrContatti] = useState([])
  const { user, /* isAuthenticated,  */getAccessTokenSilently } = useAuth0();
  const [token, setToken] = useState("");
  /* const [ordinino,setOrdinino] = useState() */

  const funzioneScegliID = function (id, dato, nuovaFase, tipo, cosa) {
    let update = nuovaGaranziaTemp;
    if (tipo) {
      if (tipo === "ordine") {
        console.log("cosa", cosa)
        update.idSpedPS = cosa["N_rif_PrestaShop"];
        update["nomeCliente"] = cosa["nomeCliente"];
        update["dataOrd"] = cosa["dataOrd"]
      } else if (tipo === "articolo") {
        console.log("cosa", cosa)
        update["Cod Viglietti Sport"] = cosa["Cod Viglietti Sport"]
        update["imgIDps"] = cosa["imgIDps"]
        update["prodIDps"] = cosa["prodIDps"]
        update["Descrizione Articolo"] = cosa["Descrizione Articolo"]
        update["Produttore"] = cosa["Produttore"]
        setFornitoreInput(cosa["Produttore"])
        setArticoloRif(cosa)
      } else if (tipo === "fornitore") {
        update["nomeForn"] = cosa["nome"]
        update["istruzioniReso"] = cosa["istruzioniReso"]
        setFornitoreRif(cosa)
      } else if (tipo === "contatto") {
        setContattoRif(cosa);
        update.mailRappr = cosa["mail"];
        update.nomeRappr = cosa["nome"];
        update.mailRapprCC = cosa["cc"];
      }
    }
    update[dato] = id
    /* update = _.set(_.cloneDeep(nuovaGaranziaTemp), dato, id); */ /* per il momento tolgo visto che non c'è roba nestata */
    setNuovaGaranziaTemp(update);
    setFase(nuovaFase);
  }

  useEffect(() => {
    const getUserMetadata = async () => {
      try {
        const accessToken = await getAccessTokenSilently();
        setToken(accessToken);
      } catch (e) {
        console.log(e.message);
      }
    };
    getUserMetadata();
  }, [getAccessTokenSilently, user?.sub]);

  useEffect(() => {
    if (idArticolo && idSpedizione) {
      setFase(3)
    }
  }, [idArticolo]);

  useEffect(() => {
    if (fase === 2) {
      if (!token) {
        console.warn("sto aspettando un token")
        return;
      }
      fetch(apiUrl + "/logistica/ricerca/ricOrdineCodSpedQuerySep/" + nuovaGaranziaTemp.idSpedOriginale, { headers: { Authorization: "Bearer " + token } })
        .then(resp => resp.json())
        .then(data => setOrdineRif(data || "NO DATA"))
    } else if (fase === 3) {
      if (fornitoreInput) {
        if (!token) {
          console.warn("sto aspettando un token")
          return;
        }
        fetch(apiUrl + "/logistica/garanzia/ricFornitorePerGaranzia/" + fornitoreInput, { headers: { Authorization: "Bearer " + token } })
          .then(resp => resp.json())
          .then(data => setArrFornitori(data || []))
      }
    } else if (fase === 4) {
      if (nuovaGaranziaTemp.idFornitore) {
        if (!token) {
          console.warn("sto aspettando un token")
          return;
        }
        fetch(apiUrl + "/anagrafiche/daFornitore/" + nuovaGaranziaTemp.idFornitore, { headers: { Authorization: "Bearer " + token } })
          .then(resp => resp.json())
          .then(data => setArrContatti(data || []))
      }
    }
  }, [fase]);

  const cercaFornitore = async function () {
    if (!token) {
      console.warn("sto aspettando un token")
      return;
    }
    fetch(apiUrl + "/logistica/garanzia/ricFornitorePerGaranzia/" + fornitoreInput, { headers: { Authorization: "Bearer " + token } })
      .then(resp => resp.json())
      .then(data => setArrFornitori(data || []))
  }

  const creaNuovaGaranzia = async function () {
    if (!token) {
      console.warn("sto aspettando un token")
      return;
    }
    try {
      const data = {
        documento: nuovaGaranziaTemp,
        utente: utente.username,
        permessi: utente.permessiAPI
      }
      const config = {
        headers: {
          'Authorization': 'Bearer ' + token,
          'Content-Type': 'application/json'
        }
      }
      axios.post(apiUrl + "/logistica/garanzia/creaGaranzia", data, config)
        .then((resp) => {
          if (resp.data.errno) {
            /* setAlertSalvataggio(`Errore nel salvataggio: ${resp.data.code} - ${resp.data.message}`) */
          } else {
            /* setAlertSalvataggio(false);
            setResultSalvataggio(resp.data); */
            setRicerca(false)
            setUrlRicerca(apiUrl + "/logistica/garanzia/ricercaGaranzie/")
            setListeOrdiniDaAltrove([])
            setNuovaGaranzia(false);
          }
        })
    } catch (err) {
      console.log("Errore nell'invio del prodotto alle API': " + err)
      throw err;
    }
  }

  return (
    <div className="fixed-l w-100-l sfondoColAlt h-100 colonnaTuttaPagina-ns flex justify-center">
      <div className="ma3-ns br4-ns sfondoBiancoTema w-50 h-100 h-97-ns pa2">
        <div className="flex flex-wrap justify-between pt2">
          <div className="w-100 flex flex-wrap">
            <div className="w-10">
            </div>
            <div className="tc w-80 b pa2 f4">Crea nuova garanzia
            </div>
            <div className="w-10">
              <button className="dim tastoInputOrizzontale br3" onClick={() => {
                setRicerca(false)
                setUrlRicerca(apiUrl + "/logistica/garanzia/ricercaGaranzie/")
                setListeOrdiniDaAltrove([])
                setNuovaGaranzia(false)
              }}
              >{stilePulsanti.tastoChiudiAspetto}</button>
            </div>
          </div>
          <div className="w-100 flex justify-center pa3">
              {fase>1 && <button onClick={()=>setFase(fase-1)} className={stilePulsanti.buttonClassesWhite}>indietro</button>}
          </div>
        </div>
        <div className="pa2 flex flex-wrap">
          {fase === 1 && <div className="flex flex-wrap justify-center">
            <div className="w-third mt4 pt4 tc">
              <h3 className="pb3 bb bordoColAlt">1. Seleziona un ordine</h3>
              <div className="mb3" >Oppure crea una garanzia da zero<br />(in caso di clienti negozio o altro)</div>
              <button className={stilePulsanti.buttonClassesWhite} onClick={creaNuovaGaranzia}>Garanzia vuota</button>
            </div>
            <div className="w-50 bl bordoColAlt">
              <RicercaAvanzataPochiCampi
                setUrlRicerca={setUrlRicerca}
                setUrlParametri={() => {}}
                page={1}
                perPage={10}
                setTotalRows={setTotalRows}
                setListaOrdini={setData}
                campiRicerca={campiRicercaOrdinePerGaranzia}
                inputIniziale={inputRicercaOrdinePerGaranziaVuoto}
                inputVuoto={inputRicercaOrdinePerGaranziaVuoto}
                urlRicerca={apiUrl + "/logistica/ricerca/ricercaOrdiniDBavanzataPagination/"}
                setRicerca={setRicerca}
              />
            </div>

            {data && areaOrdini([5], "anteprimaOrdiniGaranzie", data, 5, funzioneScegliID)}
          </div>}

          {fase === 2 && <div className="mt3 flex flex-wrap items-center justify-center">
            <div className="w-third mt4 pt4 tc">
              <h3 className="pb3 bb bordoColAlt">2. Scegli l'articolo</h3>
            </div>
            <div className="w-50">
              {ordineRif?.articoliArr?.length > 0 && ordineRif.articoliArr.map((articolo) => {
                if (articolo["Cod Viglietti Sport"] || articolo["Codice EAN"]) {
                  return (<RiquadrinoArticolo
                    articolo={articolo}
                    funzioneScegliID={funzioneScegliID}
                    scelto={false}
                  />)
                }
              })}
            </div>
          </div>
          }

          {fase === 3 && <div className="w-100 h-50 flex flex-wrap items-center justify-center">
            <div className="w-50 tc">
              <h3 className="pb3 bb bordoColAlt">3. Scegli il fornitore</h3>
              <div className=" flex items-center">
                <label for="inputBrand">Nome brand</label>
                <input
                  className="db w-80 ba bordoColScrittaDef-20 ml3 mr3 pa2 br2"
                  name="inputBrand"
                  type="text"
                  onChange={(e) => setFornitoreInput(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      cercaFornitore();
                    }
                  }}
                  value={fornitoreInput}
                  autoComplete="off"
                ></input>
                <button
                  className={stilePulsanti.buttonClassesWhiteNoBorder + " w-10"}
                  onClick={cercaFornitore}>{stilePulsanti.tastoCercaAspetto}</button>
              </div>
              <h3 className="pb3">oppure</h3>
              <button onClick={() => setFase(5)} className={stilePulsanti.buttonClassesWhite}>Prosegui senza fornitore e senza contatti</button>
              <div className="mt3">Se procedi in questo modo, non potrai creare automaticamente le mail per warranties e le spedizioni di reso a produttore.</div>
            </div>
            <div className="w-50 tc">
              {(arrFornitori.trovati && arrFornitori.trovati > 0)
                ? arrFornitori.elenco.map(fornitore => <div className="ml4 mr4 mb3 ba bordoColAlt br4"><RiquadrinoFornitore elemento={fornitore} funzioneScegliID={funzioneScegliID} /></div>)
                : <p>Nessun brand corrispondente.</p>}
            </div></div>}

          {fase === 4 && <div className="w-100 flex flex-wrap mt4">
            <div className="w-100 tc">
            </div>
            <div className="w-50 tc bordoColAlt">
              <h3 className="pb3 bb bordoColAlt">4. Scegli un contatto</h3>
              <h3 className="pb3">oppure</h3>
              <button onClick={() => setFase(5)} className={stilePulsanti.buttonClassesWhite}>Prosegui senza contatto</button>
              <div className="mt3">Se procedi in questo modo, non potrai creare automaticamente le mail per warranties.</div>

            </div>
            <div className="w-50 h-100 sezioneConScroll">
              {(arrContatti.trovati && arrContatti.trovati > 0)
                ? arrContatti.elenco.map(contatto => <div className="ml4 mr4 mb3 ba bordoColAlt br4"><RiquadrinoContatto elemento={contatto} funzioneScegliID={funzioneScegliID} /></div>)
                : <p>Nessun contatto trovato.</p>}
            </div>
          </div>}

          {fase === 5 && <div className="w-100 tc pa4 ma4">
            <button
              className={stilePulsanti.buttonClassesGreen}
              onClick={() => {
                creaNuovaGaranzia();
              }}
            >CREA GARANZIA</button>
          </div>}
        </div>
      </div>
      <div className="w-third pa3 flexAlignStart flex-wrap">
        {fase > 1 &&
          <div className="w-100">
            <div className="bordoColAlt ba br4">
              <RiquadrinoOrdine
                ordine={{
                  "ID Spedizione": ordineRif?.spedEclifor?.[0]?.["ID Spedizione"],
                  "Stato_Ordine": ordineRif?.spedEclifor?.[0]?.["Stato_Ordine"],
                  nomeCognomeSpedizione: ordineRif?.spedEclifor?.[0]?.["NomeCognome"],
                  dataOrd: ordineRif?.spedEclifor?.[0]?.["Data_inserimento_Spedizione"],
                  "Tipo": ordineRif?.spedEclifor?.[0]?.["Tipo"],
                  "Data_partenza": ordineRif?.spedEclifor?.[0]?.["Data_partenza"],
                  "Partenza_da": ordineRif?.spedEclifor?.[0]?.["Partenza_da"],
                }}
              />
            </div>
          </div>}
        {fase > 2 && <div className="w-two-thirds sfondoBiancoTema br4"><div className="br4 flex flex-wrap items-center pa2">
          <RiquadrinoArticolo
            articolo={articoloRif}
            funzioneScegliID={funzioneScegliID}
            scelto={true}
          />
        </div></div>}
        <div className="w-third pl3">
          {fase > 3 && <div className="w-100 h-50 pb2"><div className="sfondoBiancoTema h-100 br4 pa2">
            <div className="tc b">{fornitoreRif.nome}</div>
          </div></div>}
          {fase > 4 && <div className="w-100 h-50 pt2"><div className="sfondoBiancoTema h-100 br4 pa2">
            <div className="tc b">{contattoRif.nome}</div>
          </div></div>}
        </div>
      </div>
      {/*  <div className="sezioneConScroll flex flex-wrap">
        <pre className="w-20">{JSON.stringify(nuovaGaranziaTemp, null, 2)}</pre>
        <pre className="w-20">{JSON.stringify(ordineRif, null, 2)}</pre>
        <pre className="w-20">{JSON.stringify(arrFornitori, null, 2)}</pre>
        <pre className="w-20">{JSON.stringify(arrContatti, null, 2)}</pre>        
      </div> */}


    </div>
  )

}

export default withLogisticaConfiguration(CreaGaranzie);